import React from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { GlobeAltIcon } from '@heroicons/react/24/outline';

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { lang } = useParams<{ lang: string }>();

  const languages = [
    { code: 'en', label: 'EN', name: 'English' },
    { code: 'fr', label: 'FR', name: 'Français' },
  ];

  const handleLanguageChange = (newLang: string) => {
    if (newLang !== lang) {
      // Change i18n language
      i18n.changeLanguage(newLang);
      
      // Update URL path
      const currentPath = location.pathname;
      const pathWithoutLang = currentPath.replace(`/${lang}`, '') || '';
      const newPath = `/${newLang}${pathWithoutLang}`;
      
      navigate(newPath, { replace: true });
    }
  };

  return (
    <div className="flex items-center gap-2" aria-label="Language switcher">
      <GlobeAltIcon className="w-4 h-4 text-gray-400" aria-hidden="true" />
      <div className="flex items-center gap-1" role="group" aria-label="Select language">
        {languages.map((language, index) => (
          <React.Fragment key={language.code}>
            <button
              onClick={() => handleLanguageChange(language.code)}
              className={`px-2 py-1 text-sm font-medium rounded transition-colors ${
                lang === language.code
                  ? 'text-primary-400 bg-primary-500/20'
                  : 'text-gray-400 hover:text-white hover:bg-gray-700'
              }`}
              title={language.name}
            >
              {language.label}
            </button>
            {index < languages.length - 1 && (
              <span className="text-gray-500 text-sm">/</span>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default LanguageSwitcher;